$(function () {
  $('#video--btn').click(function () {
    var videoPlayer = $('#video--player')
    videoPlayer.show()
    videoPlayer[0].play()
  })
})